// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';
import ReactGA from "react-ga4";

var generalCommonJS = require("../../../js/generalCommon.js");
var initialConfigCommonJS = require("../../../js/initialConfigCommon.js");

// Advisory - Energy Billing
const AppliancesReplacement = () => {
  
  useEffect(() => {    

    document.title = "HELIAS - Asesoramiento: Sustitución de electrodomésticos"     
    document.querySelector('meta[name="description"]').setAttribute("content", "El consumo de los electrodomésticos antiguos es altísimo, comprueba si necesitas sustituir alguno.");
        
    document.getElementById("formularioElectrodomesticos").className = document.getElementById("formularioElectrodomesticos").className.replaceAll(" hidden", "")
    document.getElementById("selectElectrodomestico").selectedIndex = 0
    document.getElementById("resultadoComprobacion").className += " hidden" 
    document.getElementById("consumoActualElectrodomestico").value = ""
    document.getElementById("selectUnidadConsumoElectrodomestico").value = "KWA"

    cargarConsejoElectrodomestico()

    console.log("Abro asesoramiento para el contrato de luz.")

  });

  function analisisPublicoElectrodomestico(){

    var costeMedioKwh = 0

    var tsFechaHasta = parseInt(new Date().getTime()/1000)
    var tsFechaDesde = tsFechaHasta - 2592000 //Le resto los segundos que tiene 1 mes

    var fechaDesde = new Date(tsFechaDesde*1000).toISOString().split("T")[0]
    var fechaHasta = new Date(tsFechaHasta*1000).toISOString().split("T")[0]
    
    var url = "https://api.esios.ree.es/indicators/1001?start_date="+fechaDesde+"T00%3A00%3A00%2B02%3A00&end_date="+fechaHasta+"T23%3A55%3A00%2B02%3A00&time_agg=avg&geo_ids[]=8741&geo_agg=sum&time_trunc=month&locale=es"

    document.getElementById("loaderDetalleAdvisory").className = document.getElementById("loaderDetalleAdvisory").className.replaceAll(" hidden", "")
    

    var xhttp = new XMLHttpRequest();
    xhttp.open("GET", url, true);    
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Accept', "application/json; application/vnd.esios-api-v1+json");
    xhttp.setRequestHeader('x-api-key', "cf946ba5de11ae589eae338a2fbad927a3300950daa80b683a8ab4ffe125f9ee");
    xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {          
          
          var jsonRespuestaPrecios = JSON.parse(this.responseText)

          costeMedioKwh = parseFloat(jsonRespuestaPrecios.indicator.values[jsonRespuestaPrecios["indicator"]["values"].length-1].value/1000).toFixed(3)
          analisisElectrodomestico(costeMedioKwh)

          document.getElementById("loaderDetalleAdvisory").className = document.getElementById("loaderDetalleAdvisory").className.replaceAll(" hidden", "") + " hidden"
          console.log("Precio medio PVPC último mes cargado correctamente.")  

          return costeMedioKwh
          
        }
        if (this.readyState === 4 && this.status !== 200) {                
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }            
    };
    xhttp.send();  

  }

  function cargarConsejoElectrodomestico(){

    var electrodomesticoSeleccionado=document.getElementById("selectElectrodomestico").value
    var consejo = ""
        
    if((electrodomesticoSeleccionado === "NEVERA") || (electrodomesticoSeleccionado === "NEVERAAMERICANA")){
      consejo = 'La nevera es de los electrodomésticos que más consumen ya que está todo el día conectada. No obstante, se puede ahorrar algo de dinero:'+
      '<ul class="default-list" style="padding-top:10px"><li class="success"> Aprovechando al máximo su volumen </li>'+
      '<li class="success"> Ajustando el termostato entre 4 y 6 grados centígrados </li>'+
      '<li class="success"> No dejando la puerta abierta mucho rato </li>'+
      '<li class="success"> Que no esté ubicada en la cocina cerca del horno, de un radiador o de una ventana soleada </li></ul>'
    }
    else if(electrodomesticoSeleccionado === "CONGELADOR"){
      consejo = 'El congelador es de los electrodomésticos que más consumen ya que está todo el día conectado. No obstante, se puede ahorrar algo de dinero:'+
      '<ul class="default-list" style="padding-top:10px"><li class="success"> Aprovechando al máximo su volumen </li>'+
      '<li class="success"> Ajustando el termostato entre -18 y -16 grados centígrados </li>'+
      '<li class="success"> No dejando la puerta abierta mucho rato </li>'+
      '<li class="success"> Que no esté ubicado en la cocina cerca del horno, de un radiador o de una ventana soleada </li></ul>'
    }
    else if(electrodomesticoSeleccionado === "LAVADORA") {
      consejo = "Para ahorrar en el consumo de luz por poner la lavadora, lo aconsejable es: "+
      '<ul class="default-list" style="padding-top:10px"><li class="success"> Utilizar el programa más frío posible en los lavados, así como el centrifugado más rápido</li>'+
      '<li class="success">Además, si vas a planchar la ropa, es recomendable finalizar el programa de secado antes</li></ul>'
    }
    else if(electrodomesticoSeleccionado === "SECADORA") {
      consejo = "Para ahorrar en el consumo de luz por poner la secadora, lo aconsejable es: "+
      '<ul class="default-list" style="padding-top:10px"><li class="success"> Instálala en un lugar ventilado, la acumulación de calor o cambios bruscos de temperatura afectan a su rendimiento y consumo</li>'+
      '<li class="success">Selecciona el programa adecuado al tipo de ropa que vayas a secar, si tiene programa automático úsalo</li>'+
      '<li class="success">Evita llenar demasiado la secadora, cuando está muy llena tarda más en completar el programa y la ropa seca peor</li></ul>'
    }
    else if(electrodomesticoSeleccionado === "HORNO"){
      consejo = '<ul class="default-list" style="padding-top:10px"><li class="success"> Cocina varios platos a la vez</li>'+
      '<li class="success"> No abras la puerta mientras horneas</li>'+
      '<li class="success"> Apaga el horno 5 minutos antes y aprovecha el calor residual </li>'+
      '<li class="success"> Cocina los alimentos en trozos más pequeños </li>'+
      '<li class="success"> Realiza un buen mantenimiento </li></ul>'      
    }
    else if(electrodomesticoSeleccionado === "LAVAVAJILLAS"){
      consejo = "Nuestra factura de la luz puede verse modificada: "+
      '<ul class="default-list" style="padding-top:10px"><li class="success"> Cambiando el programa del lavavajillas. Según la OCU, los consumidores pueden ahorrar hasta un 20% si utilizan un programa económico (a 50 ºC en lugar de 60 ºC)'+
      '<li class="success">Reservando el programa de lavado intenso únicamente cuando la vaijilla esté muy sucia. Al contrario de lo que podría pensarse, el programa de media carga no ahorra mucha energía, así que es mejor esperar a llenar el lavavajillas por completo para ponerlo en marcha.'
    }
    else if(electrodomesticoSeleccionado === "AC"){
      consejo = '<ul class="default-list" style="padding-top:10px"><li class="success"> Intenta que no le de el sol directamente al aparato'+
      '<li class="success"> Pon el AC a una temperatura media (Ej: 24/26 grados)</li>'+
      '<li class="success"> Ponlo en modo ECO</li>'+
      '<li class="success"> Evita ponerlo de noche</li>'+
      '<li class="success"> Revisa el aislamiento de tus ventanas para evitar pérdidas y sobretrabajo del aparato'+
      '<li class="success"> Limpia el aparato regularmente.</li></ul>'
    }
    else if(electrodomesticoSeleccionado === "BOMBACALOR"){
      consejo = 'Una vez alcanza la temperatura deseada el consumo es muy bajo por eso:'+
      '<ul class="default-list" style="padding-top:10px"><li class="success"> Evita continuas paradas y arranques del sistema, si se apaga del todo el aparato debe de hacer más esfuerzo para recuperar esa energía al encenderse de nuevo.</li>'+
      '<li class="success"> Si te marchas de la casa baja la temperatura a 17/18 grados, pero no la apagues.</li></ul>'
    }
    else if(electrodomesticoSeleccionado === "PLANCHA"){
      consejo = '<ul class="default-list" style="padding-top:10px"><li class="success">Ajusta el programa de planchado al material de la prenda</li>'+
      '<li class="success"> Intenta usarla en horas en las que tu tarifa eléctrica sea más baja.</li></ul>'
    }
    else if(electrodomesticoSeleccionado === "VITRO"){
      consejo = '<ul class="default-list" style="padding-top:10px"><li class="success">Cocina con poca agua y con los recipientes tapados o semitapados para evitar pérdidas de calor que alarguen el cocinado'+
      '<li class="success"> Apaga la vitro antes de terminar y aprovecha el calor residual que queda</li>'+
      '<li class="success"> Utiliza el fogon del tamaño más adecuado para el cazo/sartén y usa ollas a presión (reducen hasta un 50% el tiempo de cocinado y por tanto el consumo)</li></ul>'
    }

    document.getElementById("textoConsejoElectrodomesticos").innerHTML = consejo


  }

  function irAComprobacion(){    

    try{
      if(!document.getElementById("volverAsesoramientoPublico").className.includes("hidden")){      
        document.getElementById("volverAsesoramientoPublico").className = document.getElementById("volverAsesoramientoPublico").className.replaceAll(" hidden", "") + " hidden"
      }
    }
    catch(error){}

    document.getElementById("acordeonFormularioElectrodomestico").setAttribute('open', '')
    document.getElementById("formularioElectrodomesticos").className += " hidden"
    document.getElementById("tituloComparativa").innerHTML = document.getElementById("selectElectrodomestico").options[document.getElementById("selectElectrodomestico").selectedIndex].innerHTML
    document.getElementById("resultadoComprobacion").className = document.getElementById("resultadoComprobacion").className.replaceAll(" hidden", "")
    document.getElementById("divResumenResultados").className += " hidden"
    document.getElementById("consumoActualElectrodomestico").value = ""
    document.getElementById("selectUnidadConsumoElectrodomestico").value = "KWA"
    document.getElementById("divContenedorDetalleAdvisory").scrollTop = 0
    document.getElementById("consumoActualElectrodomestico").className = document.getElementById("consumoActualElectrodomestico").className.replaceAll(" error","")

  }

  function verificarElectrodomestico(){    
    
    var costeMediokWh = 0

    if(document.getElementById("consumoActualElectrodomestico").value !== ""){
      if(initialConfigCommonJS.existeSesion()){
        var configuracionEnergia = JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.EnergyConfiguration.split("#")

        if(JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.EnergyConfiguration === ""){
          costeMediokWh = parseFloat(JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.DailyEnergyBuyPrice.Value).toFixed(6)
        }
        else{
          for(var x=0; x < configuracionEnergia.length; x++){
            costeMediokWh = costeMediokWh + parseFloat(configuracionEnergia[x])
          }
      
          costeMediokWh = costeMediokWh / configuracionEnergia.length
        }  

        console.log(costeMediokWh)

        if(!isNaN(costeMediokWh)){
          console.log("Calculo con mis datos")
          analisisElectrodomestico(costeMediokWh)
        }
        else{
          console.log("Calculo con los públicos")
          analisisPublicoElectrodomestico()
        }
        
      }
      else{
        analisisPublicoElectrodomestico()
      }
    }
    else{ //Mensaje de error
      document.getElementById("consumoActualElectrodomestico").className = document.getElementById("consumoActualElectrodomestico").className.replaceAll(" error","") + " error"
      initialConfigCommonJS.mostrarMensajeInformativo("Debes introducir un valor.","negative")
    }

  }

  function analisisElectrodomestico(costeMediokWh){

    var nombreElectrodomesticoSeleccionado = document.getElementById("selectElectrodomestico").options[document.getElementById("selectElectrodomestico").selectedIndex].innerHTML.toLowerCase()
    var electrodomesticoSeleccionado=document.getElementById("selectElectrodomestico").value
    var textoConclusion = ""
    var textoSugerencia = ""
    
    var consumoElectrodomesticoUsuario = parseFloat(document.getElementById("consumoActualElectrodomestico").value.replaceAll(",","."))
    var unidadConsumoElectrodomesticoUsuario = document.getElementById("selectUnidadConsumoElectrodomestico").value
    
    var nombreElectrodomesticoEficiente = ""
    var descripcionElectrodomesticoEficiente = ""
    var consumoElectrodomesticoEficiente = 0    
    var imagenElectrodomesticoEficiente = ""
    var linkCompraElectrodomesticoEficiente = ""
    var precioOrientativo = 0

    if(electrodomesticoSeleccionado === "NEVERA"){
      nombreElectrodomesticoEficiente = "CHiQ FBM260L"
      descripcionElectrodomesticoEficiente = "Frigorífico combi 260L (187L + 73L congelador)"
      consumoElectrodomesticoEficiente = 198
      //unidadElectrodomesticoEficiente = "KWA"
      imagenElectrodomesticoEficiente = "https://cdn.idealo.com/folder/Product/200357/9/200357933/s11_produktbild_gross/chiq-fbm260l.jpg"
      linkCompraElectrodomesticoEficiente = "https://www.amazon.es/CHiQ-FBM260L-Frigor%C3%ADfico-congelador-reversibles/dp/B084D4HKKG/ref=sr_1_1?__mk_es_ES=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=D32T7R2BXSVT&keywords=frigorifico&qid=1664625555&qu=eyJxc2MiOiI3LjY4IiwicXNhIjoiNy42MyIsInFzcCI6IjYuMzcifQ%3D%3D&refinements=p_72%3A831280031%2Cp_36%3A2493686031%2Cp_n_feature_twelve_browse-bin%3A33885627031%2Cp_n_feature_four_browse-bin%3A28232584031&rnid=28232583031&s=appliances&sprefix=frigorific%2Caps%2C183&sr=1-1"
      precioOrientativo = 399
    }
    else if(electrodomesticoSeleccionado === "NEVERAAMERICANA"){      
      nombreElectrodomesticoEficiente = "Cecotec CoolMarket FD 510 WD"
      descripcionElectrodomesticoEficiente = "Frigorífico americano (510L)"
      consumoElectrodomesticoEficiente = 304
      //unidadElectrodomesticoEficiente = "KWA"
      imagenElectrodomesticoEficiente = "https://m.media-amazon.com/images/I/31mCY+ZM9cL._AC_SR38,50_.jpg"
      linkCompraElectrodomesticoEficiente = "https://www.amazon.es/dp/B0BPYS1HCJ?tag=track-ect-es-642004-21&linkCode=osi&th=1&psc=1&ascsubtag=ecSEPe80ojlxa7ejc8"  
      precioOrientativo = 799
    }
    else if(electrodomesticoSeleccionado === "CONGELADOR"){
      nombreElectrodomesticoEficiente = "Milectric FRV-140"
      descripcionElectrodomesticoEficiente = "Congelador vertical (140L)"
      consumoElectrodomesticoEficiente = 168
      //unidadElectrodomesticoEficiente = "KWA"
      imagenElectrodomesticoEficiente = "https://thumb.pccomponentes.com/w-530-530/articles/43/432514/1533-milectric-frv-140-congelador-vertical-140l-e-blanco-especificaciones.jpg"
      linkCompraElectrodomesticoEficiente = "https://www.pccomponentes.com/milectric-frv-140-congelador-vertical-140l-e-blanco"  
      precioOrientativo = 310
    }
    else if(electrodomesticoSeleccionado === "LAVADORA"){
      nombreElectrodomesticoEficiente = "Haier Serie 636 HW80-BP14636N"
      descripcionElectrodomesticoEficiente = "Lavadora 8kg"
      consumoElectrodomesticoEficiente = 47
      //unidadElectrodomesticoEficiente = "KWA"
      imagenElectrodomesticoEficiente = "https://d15v10x8t3bz3x.cloudfront.net/Immagini/2020/11/16045067/640-28_31011420_9_02_l_hw80-bp14636n-ib-M.jpg"
      linkCompraElectrodomesticoEficiente = "https://www.mediamarkt.es/es/product/_lavadora-carga-frontal-haier-hw80-bp14636n-8-kg-1400-rpm-inverter-antibacterias-vapor-blanco-1496970.html?cstrackid=053e5cf5-e53c-4911-8465-ea7f4a420f33&tduid=a347f883ded1d90746ab3e222bd3a85d&utm_campaign=rt_affiliate_performance_nsp_aon-012022_na&utm_content=2432458&utm_medium=aff-content&utm_source=tradedoubler&utm_term=affiliate_es_es_mm_2021-01-01_conversion_tradedoubler_tradedoubler_aff-content_mediamarkt_all_multidevice_2432458_multisize_all_all_all"  
      precioOrientativo = 349
    }
    else if(electrodomesticoSeleccionado === "SECADORA"){
      nombreElectrodomesticoEficiente = "Beko DS8512CX"
      descripcionElectrodomesticoEficiente = "Secadora 8 kg, Bomba de calor"
      consumoElectrodomesticoEficiente = 176
      //unidadElectrodomesticoEficiente = "KWA"
      imagenElectrodomesticoEficiente = "https://www.lacasadelelectrodomestico.com/public/storage/producto/179619/beko-ds-8512-cx-secadora-bomba-de-calor-8kg-a-16-programas-0179619-600px.jpg"
      linkCompraElectrodomesticoEficiente = "https://www.mielectro.es/secadora-bomba-calor-beko-ds8512cx-6206071/"  
      precioOrientativo = 449
    }    
    else if(electrodomesticoSeleccionado === "HORNO"){
      nombreElectrodomesticoEficiente = "Candy Smart FCS 100 X/E"
      descripcionElectrodomesticoEficiente = "Horno 70L"
      consumoElectrodomesticoEficiente = parseInt(parseFloat((800/1000) * 1 * 100))
      //unidadElectrodomesticoEficiente = "kW"
      imagenElectrodomesticoEficiente = "https://d15v10x8t3bz3x.cloudfront.net/Immagini/2018/10/15391628/640-37-33701789_FCS100X-F-58032-M.jpg"
      linkCompraElectrodomesticoEficiente = "https://www.amazon.es/dp/B073FQ4HT9?tag=hornos10-21&linkCode=ogi&th=1"  
      precioOrientativo = 149
    }
    else if(electrodomesticoSeleccionado === "LAVAVAJILLAS"){
      nombreElectrodomesticoEficiente = "BALAY 3VS506BP"
      descripcionElectrodomesticoEficiente = "Lavavajillas 12 cubiertos"
      consumoElectrodomesticoEficiente = 92
      //unidadElectrodomesticoEficiente = "KWA"
      imagenElectrodomesticoEficiente = "https://static.carrefour.es/hd_510x_/crs/cdn_static/catalog/hd/653054_00_1.jpg"
      linkCompraElectrodomesticoEficiente = "https://www.balay.es/catalogo-electrodomesticos/lavavajillas/60-cm/3VS506BP"  
      precioOrientativo = 479
    }
    else if( (electrodomesticoSeleccionado === "AC") || (electrodomesticoSeleccionado === "BOMBACALOR") ){
      nombreElectrodomesticoEficiente = "Mitsubishi Heavy SRK63ZR-W"
      descripcionElectrodomesticoEficiente = "Aire acondicionado + bomba de calor"
      consumoElectrodomesticoEficiente = parseInt(parseFloat((1600/1000) * 12 * 100)) //El consumo de referencia es en KwH, pondero a año
      //unidadElectrodomesticoEficiente = "kW"
      imagenElectrodomesticoEficiente = "https://assets.leroymerlin.es/is/image/lmes/84573549-0100-1/a-a-1x1-mitsu-hi-smart-srk63zr-w-5400f.png?$lmesBgMobile$"
      linkCompraElectrodomesticoEficiente = "https://www.airefrio.com/aire-acondicionado-1x1-mitsubishi-heavy-srk63zr-w.html"  
      precioOrientativo = 1447
    }    
    else if(electrodomesticoSeleccionado === "PLANCHA"){
      nombreElectrodomesticoEficiente = "Imetec Eco Perfect"
      descripcionElectrodomesticoEficiente = "Plancha de Vapor"
      consumoElectrodomesticoEficiente = parseInt(parseFloat((2400/1000) * 1 * 200)) //El consumo de referencia es en KwH, pondero a año
      //unidadElectrodomesticoEficiente = "kW"
      imagenElectrodomesticoEficiente = "https://m.media-amazon.com/images/I/71nvWZ5P4JL._AC_SL1500_.jpg"
      linkCompraElectrodomesticoEficiente = "https://www.amazon.es/resultados-revestimiento-cer%C3%A1mica-protecci%C3%B3n-anti-cal/dp/B08V11MR92/ref=sr_1_1_sspa?keywords=plancha+bajo+consumo&qid=1664961281&qu=eyJxc2MiOiI0LjkyIiwicXNhIjoiNC4yMCIsInFzcCI6IjIuMjUifQ%3D%3D&sr=8-1-spons&psc=1"  
      precioOrientativo = 59
    }
    else if(electrodomesticoSeleccionado === "VITRO"){
      nombreElectrodomesticoEficiente = "Teka Modelo TZ6415"
      descripcionElectrodomesticoEficiente = "Placa Vitrocerámica 4 Zonas"
      consumoElectrodomesticoEficiente = parseInt(parseFloat((6300/1000) * 2 * 365)) //El consumo de referencia es en KwH, pondero a año
      //unidadElectrodomesticoEficiente = "kW"
      imagenElectrodomesticoEficiente = "https://m.media-amazon.com/images/I/81NLnSE523L.__AC_SY445_SX342_QL70_ML2_.jpg"
      linkCompraElectrodomesticoEficiente = "https://www.amazon.es/Placa-vitrocer%C3%A1mica-6415-40239042-Teka-60/dp/B01LYFAWE8/ref=asc_df_B01LYFAWE8/?tag=googshopes-21&linkCode=df0&hvadid=195183456662&hvpos=&hvnetw=g&hvrand=6347404417545888352&hvpone=&hvptwo=&hvqmt=&hvdev=c&hvdvcmdl=&hvlocint=&hvlocphy=2724&hvtargid=pla-273568254862&th=1"  
      precioOrientativo = 175
    }
    
    //Normalizo a consumo anual
    if(unidadConsumoElectrodomesticoUsuario === "kW"){      
      
      //Ponderación de consumo: consumo en kwH * numero de horas * numero días al año

      if( (electrodomesticoSeleccionado === "AC") || (electrodomesticoSeleccionado === "BOMBACALOR") ){
        consumoElectrodomesticoUsuario = parseInt(parseFloat(consumoElectrodomesticoUsuario * 12 * 100))
      }
      else if(electrodomesticoSeleccionado === "PLANCHA"){
        consumoElectrodomesticoUsuario = parseInt(parseFloat(consumoElectrodomesticoUsuario * 1 * 200))
      }
      else if(electrodomesticoSeleccionado === "VITRO"){
        consumoElectrodomesticoUsuario = parseInt(parseFloat(consumoElectrodomesticoUsuario * 2 * 365))
      }
      else if(electrodomesticoSeleccionado === "HORNO"){
        consumoElectrodomesticoUsuario = parseInt(parseFloat(consumoElectrodomesticoUsuario * 1 * 100))
      }
      else{
        consumoElectrodomesticoUsuario = parseInt(parseFloat(consumoElectrodomesticoUsuario * 24 * 365))
      }
    }

    var costeAnualElectrodomesticoActual = parseInt(consumoElectrodomesticoUsuario * costeMediokWh)
    var ahorroComparacion = parseInt(100-((consumoElectrodomesticoEficiente*100)/consumoElectrodomesticoUsuario))
    var nuevoCosteAnual = costeAnualElectrodomesticoActual*((100-ahorroComparacion)/100)
    var tiempoAmortizacion = parseInt(precioOrientativo / (costeAnualElectrodomesticoActual-parseInt(nuevoCosteAnual)))

    if(Number.isNaN(tiempoAmortizacion)){
      tiempoAmortizacion = "demasiados"
    }

    if(!isNaN(ahorroComparacion)){

      document.getElementById("divResumenResultados").className = "vertical gap-04"          
      document.getElementById("acordeonFormularioElectrodomestico").removeAttribute('open')

      document.getElementById("divContenedorDetalleAdvisory").scrollTop = document.getElementById("divContenedorDetalleAdvisory").scrollHeight
      document.getElementById("formularioElectrodomesticos").className += " hidden"
      document.getElementById("resultadoComprobacion").className = document.getElementById("resultadoComprobacion").className.replace(" hidden", "")

      document.getElementById("consumoActual").innerHTML = consumoElectrodomesticoUsuario + " kW"
      document.getElementById("consumoNuevo").innerHTML = consumoElectrodomesticoEficiente + " kW"
      document.getElementById("gastoActual").innerHTML = costeAnualElectrodomesticoActual + "€"
      document.getElementById("gastoNuevo").innerHTML = parseInt(nuevoCosteAnual) + "€"

      if(ahorroComparacion < 0){
        //No te interesa      
        document.getElementById("iconoResultado").innerHTML = "thumb_up"
        document.getElementById("contenedorResultados").className = "message medium left success"      
        textoConclusion = "No te interesa cambiar tu "+nombreElectrodomesticoSeleccionado      
        textoSugerencia = 'De hecho tu '+nombreElectrodomesticoSeleccionado+' es mejor que la que usamos actualmente como referencia. Si nos escribes <a href="https://fevergy.com/Contacto" rel="noopener noreferrer" target="_blank" class="link inline-link">aquí</a> indicando la marca y el modelo la usaremos como nueva referencia y ayudarás a más usuarios a encontrar fácil y rápido el mejor electrodoméstico relación eficiencia/precio del mercado y contribuirás al ahorro energético global.'

        document.getElementById("linkElectrodomesticoRecomendado").className = document.getElementById("linkElectrodomesticoRecomendado").className.replaceAll(" hidden", "") + " hidden"

      }
      else{
        if(ahorroComparacion >= 50){
          document.getElementById("iconoResultado").innerHTML = "thumb_down"
          document.getElementById("contenedorResultados").className = "message medium left error"      
          textoConclusion = "Debes cambiar tu "+nombreElectrodomesticoSeleccionado+" urgentemente, ahorrarás un <strong>"+ahorroComparacion+"% / "+(costeAnualElectrodomesticoActual-parseInt(nuevoCosteAnual))+"€</strong> anualmente."                        
          textoSugerencia = "Te sugerimos este, lo amortizarías en "+tiempoAmortizacion+" años..."

          document.getElementById("linkElectrodomesticoRecomendado").className = document.getElementById("linkElectrodomesticoRecomendado").className.replaceAll(" hidden", "")
          document.getElementById("linkElectrodomesticoRecomendado").href = linkCompraElectrodomesticoEficiente
          document.getElementById("linkImagenElectrodomesticoEficiente").src = imagenElectrodomesticoEficiente
          document.getElementById("nombreElectrodomesticoRecomendado").innerHTML = nombreElectrodomesticoEficiente
          document.getElementById("descripcionElectrodomesticoRecomendado").innerHTML = descripcionElectrodomesticoEficiente
          document.getElementById("precioElectrodomesticoRecomendado").innerHTML = precioOrientativo + " €"
        }
        else if ( (ahorroComparacion >= 0) && (ahorroComparacion < 25) ){
          
          if(tiempoAmortizacion <= 10){ //Te recomendamos cambiarla, pero el ahorro sería relativamente bajo
            document.getElementById("iconoResultado").innerHTML = "thumbs_up_down"
            document.getElementById("contenedorResultados").className = "message medium left warning"      
            textoConclusion = "Te recomendamos cambiar tu "+nombreElectrodomesticoSeleccionado+" ya que aun siendo un ahorro relativamente bajo (<strong>"+ahorroComparacion+"% / "+(costeAnualElectrodomesticoActual-parseInt(nuevoCosteAnual))+"€</strong> anualmente) la amortizarías rápido."                              
            textoSugerencia = "Te sugerimos este, lo amortizarías en "+tiempoAmortizacion+" años..."

            document.getElementById("linkElectrodomesticoRecomendado").className = document.getElementById("linkElectrodomesticoRecomendado").className.replaceAll(" hidden", "")
            document.getElementById("linkElectrodomesticoRecomendado").href = linkCompraElectrodomesticoEficiente
            document.getElementById("linkImagenElectrodomesticoEficiente").src = imagenElectrodomesticoEficiente
            document.getElementById("nombreElectrodomesticoRecomendado").innerHTML = nombreElectrodomesticoEficiente
            document.getElementById("descripcionElectrodomesticoRecomendado").innerHTML = descripcionElectrodomesticoEficiente
            document.getElementById("precioElectrodomesticoRecomendado").innerHTML = precioOrientativo + " €"
          }        
          else{ //No te interesa, quédate como estás.
            document.getElementById("iconoResultado").innerHTML = "thumb_up"
            document.getElementById("contenedorResultados").className = "message medium left success"      
            textoConclusion = "No te interesa cambiar tu "+nombreElectrodomesticoSeleccionado+", mantén la que tienes actualmente. Tu ahorro sería bajo y tardarías demasiado en amortizarla."
            textoSugerencia = "Tardarías en amortizarlo "+tiempoAmortizacion+" años."

            document.getElementById("linkElectrodomesticoRecomendado").className = document.getElementById("linkElectrodomesticoRecomendado").className.replaceAll(" hidden", "") + " hidden"

          }        
          
        }
        else if ( (ahorroComparacion >= 25) && (ahorroComparacion < 50) ){

          if(tiempoAmortizacion <= 10){ //Te recomendamos cambiarla, pero el ahorro sería relativamente bajo
            document.getElementById("iconoResultado").innerHTML = "thumbs_up_down"
            document.getElementById("contenedorResultados").className = "message medium left warning"      
            textoConclusion = "Deberías cambiar tu "+nombreElectrodomesticoSeleccionado+", tendrías un buen ahorro (<strong>"+ahorroComparacion+"% / "+(costeAnualElectrodomesticoActual-parseInt(nuevoCosteAnual))+"€</strong> anualmente) la amortizarías rápido."
            textoSugerencia = "Te sugerimos este, lo amortizarías en "+tiempoAmortizacion+" años..."

            document.getElementById("linkElectrodomesticoRecomendado").className = document.getElementById("linkElectrodomesticoRecomendado").className.replaceAll(" hidden", "")
            document.getElementById("linkElectrodomesticoRecomendado").href = linkCompraElectrodomesticoEficiente
            document.getElementById("linkImagenElectrodomesticoEficiente").src = imagenElectrodomesticoEficiente
            document.getElementById("nombreElectrodomesticoRecomendado").innerHTML = nombreElectrodomesticoEficiente
            document.getElementById("descripcionElectrodomesticoRecomendado").innerHTML = descripcionElectrodomesticoEficiente
            document.getElementById("precioElectrodomesticoRecomendado").innerHTML = precioOrientativo + " €"
            

          }        
          else{ //No te interesa, quédate como estás.
            document.getElementById("iconoResultado").innerHTML = "thumb_up"
            document.getElementById("contenedorResultados").className = "message medium left success"      
            textoConclusion = "No te interesa cambiar tu "+nombreElectrodomesticoSeleccionado+", aun teniendo un buen ahorro (<strong>"+ahorroComparacion+"% / "+(costeAnualElectrodomesticoActual-parseInt(nuevoCosteAnual))+"€</strong> anualmente) te llevaría demasiado tiempo amortizarla."          
            textoSugerencia = "Tardarías en amortizarlo "+tiempoAmortizacion+" años."          

            document.getElementById("linkElectrodomesticoRecomendado").className = document.getElementById("linkElectrodomesticoRecomendado").className.replaceAll(" hidden", "") + " hidden"
          }        

        }  
      }            

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - Sim. Electro.', document.getElementById("iconoResultado").innerHTML, "")

      //Muestro conclusión y sugerencia
      document.getElementById("conclusion").innerHTML = textoConclusion
      document.getElementById("textoSugerencia").innerHTML = textoSugerencia

      document.getElementById("divContenedorDetalleAdvisory").scrollTop = 0
    }
    else{
      initialConfigCommonJS.mostrarMensajeInformativo("Ese consumo no parece muy coherente, revísalo y prueba de nuevo.","negative")
    }
  }

  function volver(){
    document.getElementById("formularioElectrodomesticos").className = document.getElementById("formularioElectrodomesticos").className.replaceAll(" hidden", "")
    document.getElementById("resultadoComprobacion").className += " hidden" 
    document.getElementById("consumoActualElectrodomestico").value = ""
    document.getElementById("selectUnidadConsumoElectrodomestico").value = "KWA"

    try{
      if(document.getElementById("volverAsesoramientoPublico").className.includes("hidden")){      
        document.getElementById("volverAsesoramientoPublico").className = document.getElementById("volverAsesoramientoPublico").className.replaceAll(" hidden", "")
      }
    }
    catch(error){}

  }

  return (      
    <main className="no-background">

      <section className="step">

        <div id="formularioElectrodomesticos" className="content-wrapper">          

            <div className="vertical gap-02">
              <p>Especialmente los electrodomésticos antiguos suelen tener un consumo muy elevado, por eso es recomendable comprobar su consumo y ver si interesa sustituir alguno. Además puedes vender los antiguos y amortiguarás la inversión .</p>
              <p>Dicho esto, y según la OCU, los electrodomésticos causantes de las facturas altas son los siguientes, comprueba uno a uno, sigue los consejos y verifica si te interesa cambiar alguno:</p>

              <fieldset>

                <div className="description bubble" >    
                  <fieldset className="dropdown col-md">                    
                    <div className="icon-wrapper">
                      <select id="selectElectrodomestico" onChange={() => cargarConsejoElectrodomestico()}>
                        <option value="NEVERA">Nevera</option>                        
                        <option value="NEVERAAMERICANA">Nevera americana</option>                        
                        <option value="CONGELADOR">Congelador</option>
                        <option value="LAVADORA">Lavadora</option>
                        <option value="SECADORA">Secadora</option>
                        <option value="HORNO">Horno</option>
                        <option value="LAVAVAJILLAS">Lavavajillas</option>
                        <option value="AC">Aire acondicionado</option>
                        <option value="BOMBACALOR">Bomba de calor</option>                        
                        <option value="VITRO">Vitrocerámica</option>                    
                        <option value="PLANCHA">Plancha</option>
                      </select>
                    </div>
                  </fieldset>
                  <div id="divConsejoElectrodomesticos"><p id="textoConsejoElectrodomesticos"></p></div>
                </div> 

                <fieldset>            
                  <button className="button primary full-width" onClick={() => irAComprobacion()}>¿Debo cambiarlo?</button>                           
                </fieldset>

              </fieldset>
            </div>

        </div>        

        <div id="resultadoComprobacion" className=" hidden">

          <button className="link back" onClick={() => volver()}><span className="material-icon">arrow_back</span>Volver</button>

          <fieldset>
            
            <div className="accordion-wrapper">

              <details id="acordeonFormularioElectrodomestico" className="accordion green" open>

                <summary className="title">                  
                  <h1 id="tituloComparativa" className="headline-03"> </h1>
                </summary>                

                <fieldset className="accordion-content vertical gap-04">

                  <fieldset className="columns col-sm-2 gap-04">

                    <fieldset>
                      <label>Consumo aparato actual</label>
                      <input type="text" inputMode="decimal" id="consumoActualElectrodomestico" />
                    </fieldset>
                    
                    <fieldset className="dropdown">
                      <label>Unidad de consumo</label>
                      <div className="icon-wrapper">
                        <select id="selectUnidadConsumoElectrodomestico">
                          <option value="KWA">kW Año</option>
                          <option value="kW">kW Hora</option>                        
                        </select>                  
                      </div>

                    </fieldset>

                  </fieldset>

                  <div className="message info left">            
                    <p id="labelNotaConsumoActualElectrodomestico" className="horizontal vertical-center"><span className="material-icon">info</span>Para saber el consumo de tu electrodoméstico mira la pegatina que suelen tener en el lateral o consulta la sección de especificaciones en el manual de instrucciones del aparato.</p>                
                  </div>

                  <button className="button primary full-width" onClick={() => verificarElectrodomestico()}>Comprobemos si merece la pena...</button>                     

                </fieldset>

              </details>
            </div>

            <div id="divResumenResultados" className="vertical gap-04">
              
              <div id="contenedorResultados" className="message medium left">

                <div className="horizontal">
                  <span id="iconoResultado" className="material-icon">thumb_up</span>
                  <h1 className="title" id="conclusion"> </h1>
                </div>

                <table className="min">
                  <thead>
                    <tr className="table-row">
                      <th className="table-cell label"></th>
                      <th className="table-cell value">Ahora</th>   
                      <th className="table-cell value">Con uno nuevo</th>                 
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="table-row">
                      <td className="table-cell label">Consumo anual</td>
                      <td className="table-cell value headline-03" id="consumoActual"></td>
                      <td className="table-cell value headline-03" id="consumoNuevo"></td>
                    </tr>

                    <tr className="table-row">
                      <td className="table-cell label">Gasto anual</td>
                      <td className="table-cell value headline-03" id="gastoActual"></td>                    
                      <td className="table-cell value headline-03" id="gastoNuevo"></td>
                    </tr>

                  </tbody>
                </table>

              </div>

              <p id="textoSugerencia"></p>
              
              <a id="linkElectrodomesticoRecomendado" href="www.fevergy.com" rel="noopener noreferrer" target="_blank" className="selector icon-wrapper no-icon xxl" onClick={() => generalCommonJS.registrarEventoAnalitica(ReactGA, 'CROSS-SELLING', "XSELL - "+document.getElementById("nombreElectrodomesticoRecomendado").innerHTML, "", "")}>
                <figure className="avatar size-xxl"><img id="linkImagenElectrodomesticoEficiente" src="/" alt=""/></figure>
                <div className="content vertical gap-02">
                  <h1 id="nombreElectrodomesticoRecomendado" className="headline-03"> </h1>
                  <p id="descripcionElectrodomesticoRecomendado" className="size-s"></p>
                  <p id="precioElectrodomesticoRecomendado" className="size-l link"></p>
                </div>
              </a>
              
            </div>


          </fieldset>



          

        </div>

      </section>

    </main>
  )
}

export default AppliancesReplacement